import React from 'react';
import LanguageSelect from '../containers/LanguageSelect';
import Logo from './Logo';

const Header = () => {
  return (
    <header className="header container-fluid">
      <div className="header-row row flex-items-between flex-items-xs-middle">
        <Logo className='col header-logo' />

        <div className="col header-language">
          <LanguageSelect />
        </div>
      </div>
    </header>
  );
};


export default Header;
